import React from 'react'
import NotificationSystem from 'react-notification-system'

export const Notification = React.forwardRef<NotificationSystem>(
  (props, ref) => {
    return <NotificationSystem ref={ref} />
  },
)
